import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../../../images/ahead-hash-icon-white.png";
import { CiDiscount1 } from "react-icons/ci";
import { PiSlideshow } from "react-icons/pi";
import {
  CgBox,
  CgCreditCard,
  CgFile,
  CgShoppingCart,
  CgWebsite,
} from "react-icons/cg";
import { MdAdminPanelSettings, MdMenu } from "react-icons/md";
import { MdOutlineMenuBook } from "react-icons/md";
import { GiHotMeal, GiMeal } from "react-icons/gi";
import {
  FaBell,
  FaBottleWater,
  FaBowlFood,
  FaBox,
  FaCartShopping,
  FaCreditCard,
  FaUser,
} from "react-icons/fa6";
import { AuthContext } from "../../../../contexts/AuthContext";
const SideBar = () => {
  const { pathname } = useLocation();
  const { role } = useContext(AuthContext);
  return (
    <aside className="main-sidebar sidebar-dark-primary  elevation-4">
      <Link
        to="/"
        className={
          window.location.pathname == "/"
            ? "brand-link bg-primary mot"
            : "brand-link motLightText"
        }
      >
        <img
          src={logo}
          alt="Logo"
          className="brand-image img-circle"
          style={{ opacity: ".8" }}
        />
        <span
          className={`brand-text font-weight-light  ${
            window.location.pathname == "/" ? "motText" : ""
          }`}
        >
          {process.env.REACT_APP_WEBSITE_NAME} CMS
        </span>
      </Link>

      <div className="sidebar">
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {role?.toLowerCase() === "admin" && (
              <li className="nav-item ">
                <Link
                  to="/admins"
                  className={`nav-link ${
                    /^(\/)admins(\/)|^(\/)admin/i.test(pathname)
                      ? "active mot"
                      : "motLightText"
                  }`}
                >
                  <MdAdminPanelSettings size={20} className="nav-icon me-2" />
                  <p>Admin Users</p>
                </Link>
              </li>
            )}
            <li
              className={`nav-item ${
                /^(\/)discount-coupons(\/)*|^(\/)special-meal-discounts(\/)*/i.test(
                  pathname
                )
                  ? "menu-is-opening menu-open "
                  : "motLightText"
              }`}
            >
              <a
                className={`nav-link ${
                  /^(\/)discount-coupons(\/)*|^(\/)special-meal-discounts(\/)*/i.test(
                    pathname
                  )
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <CiDiscount1 size={20} className="nav-icon me-2 -mt-1 me-1" />
                <p>
                  Discount
                  <i className="fas fa-angle-left right" />
                  {/* <span className="badge badge-info right">6</span> */}
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item ">
                  <Link
                    to="/discount-coupons"
                    className={`nav-link ${
                      /^(\/)discount-coupons(\/)|^(\/)discount-coupons/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Discount Coupons</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/special-meal-discounts"
                    className={`nav-link ${
                      /^(\/)special-meal-discounts(\/)|^(\/)special-meal-discounts/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Special Meal Discount</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className={`nav-item ${
                /^(\/)home-page-sliders(\/)*|^(\/)spot-light-areas(\/)*/i.test(
                  pathname
                )
                  ? "menu-is-opening menu-open "
                  : "motLightText"
              }`}
            >
              <a
                className={`nav-link ${
                  /^(\/)home-page-sliders(\/)*|^(\/)spot-light-areas(\/)*/i.test(
                    pathname
                  )
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <PiSlideshow size={20} className="nav-icon me-2 -mt-1 me-1" />
                <p>
                  Banners
                  <i className="fas fa-angle-left right" />
                  {/* <span className="badge badge-info right">6</span> */}
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item ">
                  <Link
                    to="/home-page-sliders"
                    className={`nav-link ${
                      /^(\/)home-page-sliders(\/)|^(\/)home-page-sliders/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Banners</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/spot-light-areas"
                    className={`nav-link ${
                      /^(\/)spot-light-areas(\/)|^(\/)spot-light-areas/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Spotlight Banners</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className={`nav-item ${
                /^(\/)news-events(\/)*|^(\/)recipes(\/)*|^(\/)jobs(\/)*/i.test(
                  pathname
                )
                  ? "menu-is-opening menu-open "
                  : "motLightText"
              }`}
            >
              <a
                className={`nav-link ${
                  /^(\/)news-events(\/)*|^(\/)recipes(\/)*|^(\/)jobs(\/)*/i.test(
                    pathname
                  )
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <CgWebsite size={20} className="nav-icon me-2 -mt-1 me-1" />
                <p>
                  Display Content
                  <i className="fas fa-angle-left right" />
                  {/* <span className="badge badge-info right">6</span> */}
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item ">
                  <Link
                    to="/news-events"
                    className={`nav-link ${
                      /^(\/)news-events(\/)|^(\/)news-events/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>News and Events</p>
                  </Link>
                </li>{" "}
                <li className="nav-item ">
                  <Link
                    to="/recipes"
                    className={`nav-link ${
                      /^(\/)recipes(\/)|^(\/)recipes/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Recipes</p>
                  </Link>
                </li>{" "}
                <li className="nav-item ">
                  <Link
                    to="/jobs"
                    className={`nav-link ${
                      /^(\/)jobs(\/)|^(\/)jobs/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="nav-icon me-2 fas fa-angle-right" />
                    <p>Jobs</p>
                  </Link>
                </li>
              </ul>
            </li>
            {/* Start Here */}
            <li className="nav-item ">
              <Link
                to="/plans"
                className={`nav-link ${
                  /^(\/)plans(\/)|^(\/)plans/i.test(pathname)
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <CgFile size={20} className="nav-icon me-2" />
                <p>Plans</p>
              </Link>
            </li>
            <li className="nav-item ">
              <Link
                to="/meals"
                className={`nav-link ${
                  /^(\/)meals(\/)|^(\/)meals/i.test(pathname)
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <GiHotMeal size={20} className="nav-icon me-2" />
                <p>Meals</p>
              </Link>
            </li>
            <li className="nav-item ">
              <Link
                to="/foods"
                className={`nav-link ${
                  /^(\/)foods(\/)|^(\/)foods/i.test(pathname)
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <FaBowlFood size={20} className="nav-icon me-2" />
                <p>Foods</p>
              </Link>
            </li>
            <li className="nav-item ">
              <Link
                to="/menu"
                className={`nav-link ${
                  /^(\/)menu(\/)|^(\/)menu/i.test(pathname)
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <MdOutlineMenuBook size={20} className="nav-icon me-2" />
                <p>Menu</p>
              </Link>
            </li>
            <li className="nav-item ">
              <Link
                to="/products"
                className={`nav-link ${
                  /^(\/)products(\/)|^(\/)products/i.test(pathname)
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <FaBottleWater size={20} className="nav-icon me-2" />
                <p>Products</p>
              </Link>
            </li>
            {/* End Here */}
            {role?.toLowerCase() === "admin" && (
              <>
                <li className="nav-item ">
                  <Link
                    to="/customers"
                    className={`nav-link ${
                      /^(\/)customers(\/)|^(\/)customers/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <FaUser size={20} className="nav-icon me-2" />
                    <p>Customers</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/carts"
                    className={`nav-link ${
                      /^(\/)carts(\/)|^(\/)carts/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <FaCartShopping size={20} className="nav-icon me-2" />
                    <p>Carts</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/orders"
                    className={`nav-link ${
                      /^(\/)orders(\/)|^(\/)orders/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <FaBox size={20} className="nav-icon me-2" />
                    <p>Orders</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/subscriptions"
                    className={`nav-link ${
                      /^(\/)subscriptions(\/)|^(\/)subscriptions/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <GiMeal size={20} className="nav-icon me-2" />
                    <p>Subscriptions</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/payments"
                    className={`nav-link ${
                      /^(\/)payments(\/)|^(\/)payments/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <FaCreditCard size={18} className="nav-icon me-2" />
                    <p>Payments</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/notifications"
                    className={`nav-link ${
                      /^(\/)notifications(\/)|^(\/)notifications/i.test(
                        pathname
                      )
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <FaBell size={20} className="nav-icon me-2" />
                    <p>Notifications</p>
                  </Link>
                </li>{" "}
              </>
            )}
            <li
              className={`nav-item ${
                /^(\/)returns(\/)*|^(\/)contact-us(\/)*|^(\/)job-applications(\/)*|^(\/)testimonials(\/)*|^(\/)party-requests(\/)*|^(\/)school-nursery-requests(\/)*/i.test(
                  pathname
                )
                  ? "menu-is-opening menu-open "
                  : "motLightText"
              }`}
            >
              <a
                className={`nav-link ${
                  /^(\/)returns(\/)*|^(\/)contact-us(\/)*|^(\/)job-applications(\/)*|^(\/)testimonials(\/)*|^(\/)party-requests(\/)*|^(\/)school-nursery-requests(\/)*/i.test(
                    pathname
                  )
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <i className="nav-icon me-2 fas fa-edit" />
                <p>
                  Online Forms
                  <i className="fas fa-angle-left right" />
                  {/* <span className="badge badge-info right">6</span> */}
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link
                    to="/returns"
                    className={`nav-link ${
                      /^(\/)returns(\/)|^(\/)returns/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Product Returns</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contact-us"
                    className={`nav-link ${
                      /^(\/)contact-us(\/)|^(\/)contact-us/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Contact Us</p>
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link
                    to="/testimonials"
                    className={`nav-link ${
                      /^(\/)testimonials(\/)|^(\/)testimonials/i.test(pathname)
                        ? "active mot"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Testimonials</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/job-applications"
                    className={`nav-link ${
                      /^(\/)job-applications(\/)|^(\/)job-applications/i.test(
                        pathname
                      )
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Job Applications</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/party-requests"
                    className={`nav-link ${
                      /^(\/)party-requests(\/)|^(\/)party-requests/i.test(
                        pathname
                      )
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Party Requests</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/school-nursery-requests"
                    className={`nav-link ${
                      /^(\/)school-nursery-requests(\/)|^(\/)school-nursery-requests/i.test(
                        pathname
                      )
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>School/Nursery Requests</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className={`nav-item ${
                /^(\/)settings(\/)*|^(\/)lookups(\/)*|^(\/)pages(\/)*|^(\/)page-gallery(\/)*|^(\/)countries(\/)*|^(\/)nationalities(\/)*|^(\/)useful-links(\/)*/i.test(
                  pathname
                )
                  ? "menu-is-opening menu-open "
                  : "motLightText"
              }`}
            >
              <a
                className={`nav-link ${
                  /^(\/)settings(\/)*|^(\/)lookups(\/)*|^(\/)pages(\/)*|^(\/)countries(\/)*|^(\/)nationalities(\/)*|^(\/)useful-links(\/)*|^(\/)external-links(\/)*/i.test(
                    pathname
                  )
                    ? "active mot"
                    : "motLightText"
                }`}
              >
                <i className="nav-icon me-2 fas fa-cog" />
                <p>
                  Settings & Content
                  <i className="fas fa-angle-left right" />
                  {/* <span className="badge badge-info right">6</span> */}
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link
                    to="/settings"
                    className={`nav-link ${
                      /^(\/)settings(\/)*/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Settings</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/lookups"
                    className={`nav-link ${
                      /^(\/)lookups(\/)*/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Lookup Values</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/pages"
                    className={`nav-link ${
                      /^(\/)pages(\/)*|^(\/)page-gallery(\/)*/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Pages & Content</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/countries"
                    className={`nav-link ${
                      /^(\/)countries(\/)*/i.test(pathname)
                        ? "active motLight"
                        : "motLightText"
                    }`}
                  >
                    <i className="fas fa-angle-right me-2 nav-icon" />
                    <p>Countries</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item ">
              <a
                href="https://admin.nutricubkids.com/user-manual/"
                target="_blank"
                className="nav-link motLightText"
              >
                <i className="nav-icon me-2 fas fa-file" />
                <p>User Manual</p>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default SideBar;
